import styles from '../../../../pageStructure/mainContentPending/MainContentPending.module.css';

const SigningDocumentContentPending = () => {
    return (
        <div className={styles.ModalContentPending}>
            <div className={styles.longPendingItem} />
            <div className={styles.longPendingItem} />
            <div className={styles.smallPendingItem} />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default SigningDocumentContentPending;
